const STRIPE_PUBLISHABLE = process.env.NODE_ENV === 'production'
  ? 'pk_live_N6skJJ1RKvKGGqj5oVJW2KSO'
  : 'pk_test_CitJD8CuJUuY8q67rFDIhaiP';

export default STRIPE_PUBLISHABLE;


// WEBPACK FOOTER //
// ./src/stripe.js